import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockSettings, { BlockJustify } from '../../../models/BlockSettings';
import SubBlockMenuData from './SubBlockMenuData';

class BlockMenuListFixedMax3Data {
  title: BlockComponentText;
  titleImage: BlockComponentImage;
  backgroundImage: BlockComponentImage;
  menus: SubBlockMenuData[];
  settings: BlockSettings;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockMenuListFixedMax3Data {
  export function make(
    title?: string,
    titleImage?: string,
    backgroundImage?: string,
    menus?: SubBlockMenuData[],
    settings?: BlockSettings,
  ): BlockMenuListFixedMax3Data {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      titleImage: titleImage ? BlockComponentImage.make(titleImage) : undefined,
      backgroundImage: BlockComponentImage.make(backgroundImage),
      menus,
      settings: settings || BlockSettings.getDefault(undefined, BlockJustify.START),
    };
  }

  export function getDefault(title = 'タイトル', titleImage = '', backgroundImage = ''): BlockMenuListFixedMax3Data {
    return make(
      `<p><strong>${title}</strong></p>`,
      titleImage,
      backgroundImage,
      [
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
      ],
    );
  }
}

export default BlockMenuListFixedMax3Data;
